import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  Typography,
  FormControl,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Panel from "common/components/Panel";
import Pagination from "common/components/Pagination";
import moment from "moment";
import Resource from "common/components/Resource";
import DownloadCSV from "core/DownloadCSV";

class ListUsers extends Component {
  state = {
    searchFilter: {},
  };

  handleSearchFilterChange = (filterName, filterValue) => {
    this.setState((prevState) => ({
      ...prevState,
      searchFilter: {
        ...prevState.searchFilter,
        [filterName]: filterValue,
      },
    }));
  };

  render() {
    const { classes, history, match } = this.props;
    const { searchFilter } = this.state;
    const queryParams = {};

    if (searchFilter.email) {
      queryParams.email_like = searchFilter.email;
    }
    if (searchFilter.phone) {
      queryParams.phone_like = searchFilter.phone;
    }
    if (searchFilter.firstName) {
      queryParams.first_name_like = searchFilter.firstName;
    }
    if (searchFilter.lastName) {
      queryParams.last_name_like = searchFilter.lastName;
    }

    const debouncedSearchFilter = debounce(this.handleSearchFilterChange, 500);

    const handleSearchFilterChange = (e) =>
      debouncedSearchFilter(e.target.name, e.target.value);

    return (
      <Panel
        title="Users"
        action={<DownloadCSV apiUrl="users/export" title="Export" />}
      >
        <Fragment>
          <Grid container direction="row" spacing={2}>
            <Grid size={{ xs: 3 }}>
              <FormControl className={classes.search}>
                <TextField
                  id="searchFilter"
                  type="email"
                  name="email"
                  label="Email"
                  onChange={handleSearchFilterChange}
                />
              </FormControl>
            </Grid>
            {/* <Grid size={{ xs: 3 }}>
              <FormControl className={classes.search}>
                <TextField
                  id="phoneSearchFilter"
                  type="text"
                  name="phone"
                  label="Phone"
                  onChange={handleSearchFilterChange}
                />
              </FormControl>
            </Grid> */}
            <Grid size={{ xs: 3 }}>
              <FormControl className={classes.search}>
                <TextField
                  id="nameSearchFilter"
                  name="firstName"
                  label="First name"
                  onChange={handleSearchFilterChange}
                />
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl className={classes.search}>
                <TextField
                  id="nameSearchFilter"
                  name="lastName"
                  label="Last name"
                  onChange={handleSearchFilterChange}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Resource
            name="users"
            queryParams={queryParams}
            error={() => <Typography>Could not load users</Typography>}
            render={(users, { nextPage, prevPage, page }) => (
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    {/* <TableCell>Phone number</TableCell> */}
                    <TableCell>Access Level</TableCell>
                    <TableCell>Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.length ? (
                    users.map((user) => (
                      <TableRow hover key={user.id}>
                        <TableCell
                          className={classes.clickable}
                          onClick={() =>
                            history.push(`${match.url}/edit/${user.id}`)
                          }
                        >
                          {user.id}
                        </TableCell>
                        <TableCell>
                          {user.first_name} {user.last_name}
                        </TableCell>
                        <TableCell>{user.email}</TableCell>
                        {/* <TableCell>{user.phone || "-"}</TableCell> */}
                        <TableCell>{user.access_level}</TableCell>
                        <TableCell>
                          {moment(user.updated_at).format("YYYY-MM-DD")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5}>
                        No additional data found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={6} className={classes.pagination}>
                      <Pagination
                        page={page}
                        nextPage={nextPage}
                        prevPage={prevPage}
                        items={users}
                      />
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            )}
          />
        </Fragment>
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  pagination: {
    textAlign: "right",
  },
  table: {
    minWidth: 700,
  },
  search: {
    width: "100%",
  },
});

ListUsers.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ListUsers);
